import { Breakpoints } from 'main/settings'; 

( function Cards() {

    const $cards_containers = $(document.querySelectorAll( '.js-eq-cards' ));
    const $cards = $(document.querySelectorAll( '.js-card' ) );

    equalizeHeights();

    $(window).on( 'resize', equalizeHeights );

    /**
     * Equalize heights
     */
    function equalizeHeights() {

        $cards_containers.each( ( index, container ) => {

            const $contents = $(container).find( '.js-card-content' );
            let heights = [];
            let max_height;

            // First, reset to normal heights
            $contents.css( 'height', 'auto' );

            // Skip for small screens
            if( ! Breakpoints.mdUp() ) {
                return;
            }

            // Get heights of all summaries within same row
            $contents.each( ( index, content ) => {

                heights.push( $(content).height() );

            } );

            // Max height
            max_height = Math.max( ...heights );

            // Do it!
            $contents.height( max_height );

         
        } );
    }


} )();


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/cards.js